import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  @Input() appAutofocus = '';

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    let input = this.elementRef.nativeElement;

    if (input.nodeName !== 'INPUT' || this.appAutofocus) {
      input = input.querySelector(this.appAutofocus || 'input');
    }

    input.focus();
  }
}
